import { createFileRoute } from '@tanstack/react-router';

import { FinanceSettingsPage } from '../../../features/finance/ui/settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/finance')({
  // Срок оплаты счетов настраивает только `finance.manage`; остальным раздел в меню не показывается.
  beforeLoad: requireSettingsPermission('finance.manage'),
  component: FinanceSettingsPage,
});
